import { render, staticRenderFns } from "./DiscoverySettings.vue?vue&type=template&id=9c49fd86&scoped=true&"
import script from "./DiscoverySettings.vue?vue&type=script&lang=js&"
export * from "./DiscoverySettings.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverySettings.vue?vue&type=style&index=0&id=9c49fd86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c49fd86",
  null
  
)

export default component.exports